{
  "sidebar": {
    "dashboard": "Վահանակ",
    "reports": "Հաճախելիություն",
    "devices": "Սարքեր",
    "employees": "Աշխատակիցներ",
    "entriesExits": "Մուտքեր/Ելքեր",
    "users": "Օգտատերեր",
    "settings": "Կարգավորումներ",
    "branding": "Բրենդինգ",
    "workSchedule": "Աշխատանքային գրաֆիկ",
    "holidays": "Տոներ",
    "timeOff": "Արձակուրդ",
    "collapse": "Փակել",
    "expand": "Բացել ընտրացանկը"
  },
  "users": {
    "title": "Օգտատերեր",
    "addNew": "+ Նոր օգտատեր",
    "filters": {
      "allRoles": "Բոլոր դերերը",
      "user": "Օգտատեր",
      "admin": "Ադմինիստրատոր",
      "superAdmin": "Գերադմինիստրատոր"
    },
    "filterByRole": "Զտել ըստ դերի",
    "failedToLoad": "Չհաջողվեց բեռնել տվյալները: Խնդրում ենք կրկին փորձել:",
    "empty": "Օգտատերեր դեռ չկան:",
    "columns": {
      "name": "Անուն",
      "email": "Էլ. հասցե",
      "role": "Դեր",
      "status": "Կարգավիճակ",
      "devices": "Սարքեր",
      "created": "Ստեղծված",
      "actions": "Գործողություններ"
    },
    "actions": {
      "edit": "Խմբագրել",
      "resetPassword": "Վերականգնել գաղտնաբառը",
      "delete": "Ջնջել"
    },
    "selfManageHint": "Սեփական հաշիվը կառավարել հնարավոր չէ — օգտագործեք վերևի վահանակը:",
    "confirm": {
      "delete": "Ջնջե՞լ {{name}} օգտատիրոջը:"
    }
  },
  "schedule": {
    "title": "Աշխատանքային գրաֆիկ",
    "subtitle": "Սահմանեք ձեր ընկերության ստանդարտ աշխատանքային ժամերը: Ընդմիջման տևողությունը ավտոմատ կերպով հանվում է յուրաքանչյուր աշխատակցի աշխատած ժամերից:",
    "sectionTitle": "Աշխատանքային ժամեր",
    "shiftStart": "Աշխատանքի սկիզբ",
    "shiftEnd": "Աշխատանքային օրվա ավարտ",
    "breakMinutes": "Ընդմիջում",
    "minutes": "րոպե",
    "breakHint": "Ֆիքսված չվճարվող ընդմիջում, որը հանվում է ամեն օր աշխատած ժամանակից:",
    "saving": "Պահպանվում է…",
    "submit": "Պահպանել գրաֆիկը",
    "success": "Աշխատանքային գրաֆիկը թարմացվել է:",
    "failed": "Չհաջողվեց պահպանել գրաֆիկը: Խնդրում ենք կրկին փորձել:",
    "lateGrace": "Ուշացման թույլատրելի րոպեներ",
    "lateGraceHint": "Մինչև այս րոպեների ուշացումը չի տուգանվում",
    "lateDeductionPercent": "Ուշացման պահում (ժամային դրույքի %)",
    "lateDeductionHint": "Ժամային դրույքի տոկոսը, որը պահվում է թույլատրելիից ավելի ուշացած րոպեների համար։ 0 = ամբողջ ժամային դրույք (100%)",
    "lateDeductionFixed": "Տոկոսի փոխարեն պահել ֆիքսված գումար",
    "lateDeductionFixedHint": "Միացված դեպքում օգտագործվում է ստորև նշված ֆիքսված գումարը՝ տոկոսի փոխարեն:",
    "lateDeductionAmount": "Ֆիքսված պահում ուշացման մեկ ժամի համար (AMD)",
    "lateDeductionAmountHint": "Պահվում է թույլատրելիից ավելի ուշացման յուրաքանչյուր ժամի համար (օր. 1000 → 2 ժ ուշացում = 2000):",
    "workingDays": "Աշխատանքային օրեր",
    "workingDaysHint": "Ընտրեք, թե շաբաթվա որ օրերն են աշխատանքային: Պետք է ընտրված լինի առնվազն մեկ օր:",
    "days": {
      "mon": "Երկ",
      "tue": "Երք",
      "wed": "Չոր",
      "thu": "Հնգ",
      "fri": "Ուրբ",
      "sat": "Շաբ",
      "sun": "Կիր"
    },
    "errors": {
      "invalidTime": "Մուտքագրեք ճիշտ ժամ (ՎՎ:ՐՐ):",
      "invalidBreak": "Ընդմիջումը պետք է լինի ամբողջ թիվ (0 կամ ավելի) րոպե:",
      "invalidGrace": "Մուտքագրեք ոչ բացասական ամբողջ թիվ",
      "invalidDeduction": "Մուտքագրեք տոկոս 0-ից 100-ի սահմաններում",
      "invalidAmount": "Մուտքագրեք ոչ բացասական գումար",
      "noWorkingDays": "Ընտրեք առնվազն մեկ աշխատանքային օր:"
    },
    "latenessSection": "Ուշացումների կանոններ",
    "daysPerWeek": "Աշխատանքային օրեր շաբաթում (լողացող հանգստյան օր)",
    "daysPerWeekOff": "Անջատված — ըստ նշված օրերի",
    "daysPerWeekHint": "Օրինակ՝ 6. յուրաքանչյուր շաբաթ մեկ չնշված օր ինքնաբերաբար կհամարվի հանգստյան (X), առանց տուգանքի: Աշխատակցի քարտում նշված արժեքը գերակայում է:"
  },
  "branding": {
    "title": "Բրենդինգ",
    "subtitle": "Այս կարգավորումները կիրառվում են ձեր ընկերության ինտերֆեյսի, PDF հաշվետվությունների և էլ. փոստի ծանուցումների վրա:",
    "logo": {
      "sectionTitle": "Ընկերության լոգոտիպ",
      "upload": "Բեռնել նոր լոգոտիպ",
      "hint": "PNG, JPG կամ SVG: Առավ. 512 ԿԲ:",
      "errorType": "Ընդունվում են միայն PNG, JPG և SVG ֆայլեր:",
      "errorSize": "Ֆայլը պետք է լինի 512 ԿԲ կամ ավելի փոքր:",
      "uploading": "Բեռնվում է…",
      "submit": "Բեռնել լոգոտիպը",
      "ariaCurrentLogo": "{{name}}-ի ընթացիկ լոգոտիպը",
      "noLogo": "Լոգոտիպ դեռ չի բեռնվել:",
      "success": "Լոգոտիպը հաջողությամբ թարմացվել է:",
      "failed": "Չհաջողվեց բեռնել լոգոտիպը: Խնդրում ենք կրկին փորձել:"
    },
    "color": {
      "sectionTitle": "Բրենդի գույն",
      "label": "Հիմնական գույն",
      "ariaLabel": "Ընտրել բրենդի հիմնական գույնը",
      "saving": "Պահպանվում է…",
      "submit": "Պահպանել գույնը",
      "success": "Բրենդի գույնը թարմացվել է:",
      "failed": "Չհաջողվեց թարմացնել գույնը: Խնդրում ենք կրկին փորձել:"
    }
  },
  "editWebUserDialog": {
    "titleNew": "Նոր օգտատեր",
    "titleEdit": "Խմբագրել օգտատիրոջը — {{name}}",
    "nameLabel": "Անուն",
    "namePlaceholder": "Լրիվ անուն",
    "emailLabel": "Էլ. հասցե",
    "emailPlaceholder": "user@example.com",
    "passwordLabel": "Գաղտնաբառ",
    "passwordPlaceholder": "Նվազ. 8 նիշ",
    "roleLabel": "Դեր",
    "activeLabel": "Ակտիվ",
    "cannotDeactivateSelf": "(անհնար է ապաակտիվացնել սեփական հաշիվը)",
    "cannotChangeOwnRole": "Անհնար է փոխել սեփական դերը: Օգտագործեք մեկ այլ գերադմինի հաշիվ:",
    "saveFailed": "Չհաջողվեց պահպանել"
  },
  "resetWebUserPasswordDialog": {
    "title": "Վերականգնել գաղտնաբառը",
    "subtitle": "Սահմանել նոր գաղտնաբառ {{name}}-ի համար:",
    "newPasswordLabel": "Նոր գաղտնաբառ",
    "confirmPasswordLabel": "Հաստատեք գաղտնաբառը",
    "newPasswordPlaceholder": "Նվազ. 8 նիշ",
    "confirmPasswordPlaceholder": "Կրկնեք նոր գաղտնաբառը",
    "errors": {
      "tooShort": "Գաղտնաբառը պետք է լինի առնվազն 8 նիշ:",
      "mismatch": "Գաղտնաբառերը չեն համընկնում:",
      "failed": "Չհաջողվեց վերականգնել: Խնդրում ենք կրկին փորձել:"
    },
    "submit": "Վերականգնել գաղտնաբառը",
    "submitting": "Վերականգնվում է…"
  },
  "platform": {
    "pagination": {
      "of": "–ից",
      "previous": "Նախորդ էջ",
      "next": "Հաջորդ էջ"
    },
    "common": {
      "loading": "Բեռնվում է…",
      "searchCompanies": "Որոնել ընկերություններ",
      "searchUsers": "Որոնել օգտատերեր",
      "searchDevices": "Որոնել սարքեր",
      "filterByCompany": "Զտել ըստ ընկերության",
      "filterByRole": "Զտել ըստ դերի",
      "filterByStatus": "Զտել ըստ կարգավիճակի",
      "devAbbr": "սարք"
    },
    "roleBadge": "Հարթակի ադմինիստրատոր",
    "consoleSubtitle": "Հարթակի կոնսոլ",
    "orders": {
      "title": "Հայտեր",
      "subtitle": "Լենդինգից ուղարկված ցուցադրության հայտեր",
      "empty": "Հայտեր դեռ չկան",
      "emptyHint": "Լենդինգի ձևով ուղարկված հայտերը կհայտնվեն այստեղ։",
      "failedToLoad": "Չհաջողվեց բեռնել հայտերը",
      "columns": {
        "date": "Ամսաթիվ",
        "name": "Անուն",
        "contacts": "Կոնտակտներ",
        "company": "Ընկերություն",
        "message": "Հաղորդագրություն",
        "status": "Կարգավիճակ"
      },
      "status": {
        "all": "Բոլորը",
        "new": "Նոր",
        "contacted": "Կապ հաստատվել է",
        "closed": "Փակված"
      },
      "statusUpdated": "Կարգավիճակը թարմացվեց։",
      "statusUpdateFailed": "Չհաջողվեց թարմացնել կարգավիճակը։"
    },
    "companies": {
      "title": "Ընկերություններ",
      "subtitle": "Հարթակի բոլոր հաճախորդ ընկերությունները",
      "addNew": "+ Նոր ընկերություն",
      "searchPlaceholder": "Փնտրել ընկերություններ…",
      "failedToLoad": "Չհաջողվեց բեռնել ընկերությունները",
      "empty": "Ընկերություններ դեռ չկան",
      "emptyHint": "Սեղմեք + Նոր ընկերություն՝ առաջին վարձակալին ավելացնելու համար:",
      "columns": {
        "name": "Անուն",
        "slug": "Նույնարկիչ",
        "status": "Կարգավիճակ",
        "rate": "Տարիֆ/ամս",
        "employees": "Աշխատակիցներ",
        "users": "Օգտատերեր",
        "devices": "Սարքեր",
        "created": "Ստեղծված",
        "actions": "Գործողություններ"
      },
      "badges": {
        "suspended": "Կասեցված",
        "active": "Ակտիվ"
      },
      "actions": {
        "reactivating": "Վերականգնվում է…",
        "reactivate": "Վերականգնել",
        "suspending": "Կասեցվում է…",
        "suspend": "Կասեցնել",
        "delete": "Ջնջել"
      },
      "toasts": {
        "suspended": "Ընկերությունը կասեցված է:",
        "reactivated": "Ընկերությունը վերականգնված է:",
        "suspendFailed": "Չհաջողվեց կասեցնել ընկերությունը: Խնդրում ենք կրկին փորձել:",
        "reactivateFailed": "Չհաջողվեց վերականգնել ընկերությունը: Խնդրում ենք կրկին փորձել:",
        "deleted": "Ընկերությունը ջնջված է:",
        "deleteFailed": "Չհաջողվեց ջնջել ընկերությունը: Խնդրում ենք կրկին փորձել:"
      },
      "confirm": {
        "suspend": "Կասեցնե՞լ {{name}} ընկերությունը: Օգտատերերը կկորցնեն մուտքը:",
        "reactivate": "Վերականգնե՞լ {{name}} ընկերությունը:",
        "delete": "Ջնջե՞լ {{name}} ընկերությունը: Սա հնարավոր չի լինի հետարկել ինտերֆեյսից:"
      },
      "editAriaLabel": "Խմբագրել {{name}}",
      "deleteAriaLabel": "Ջնջել {{name}}"
    },
    "companyEmployees": {
      "back": "Վերադառնալ ընկերություններին",
      "title": "{{company}} — աշխատակիցներ",
      "titleFallback": "Ընկերության աշխատակիցներ",
      "total": "Ընդամենը՝ {{count}}",
      "searchPlaceholder": "Որոնում ըստ անվան կամ PIN-ի…",
      "loadFailed": "Չհաջողվեց բեռնել աշխատակիցներին։",
      "empty": "Այս ընկերությունը դեռ աշխատակիցներ չունի։",
      "emptySearch": "Որոնմամբ աշխատակիցներ չեն գտնվել։",
      "columns": {
        "name": "Աշխատակից",
        "card": "Քարտ",
        "status": "Կարգավիճակ",
        "hired": "Ընդունված է"
      },
      "badges": {
        "active": "Ակտիվ",
        "inactive": "Ոչ ակտիվ"
      },
      "sync": "Համաժամացնել տերմինալի հետ",
      "syncing": "Համաժամացում…",
      "syncQueued": "Հերթագրվեց {{commands}} հրաման {{devices}} տերմինալի վրա։ Ցանկը շուտով կթարմանա։",
      "syncFailed": "Չհաջողվեց սկսել համաժամացումը։ Ստուգեք, որ ընկերությունն ունի ակտիվ տերմինալներ։",
      "editDialog": {
        "title": "Խմբագրել աշխատակցին",
        "subtitle": "Փոփոխությունները պահպանվում են հավելվածում և ուղարկվում ընկերության տերմինալներին։",
        "nameLabel": "Անուն Ազգանուն",
        "cardLabel": "Քարտ",
        "emailLabel": "Էլ. փոստ",
        "phoneLabel": "Հեռախոս",
        "activeLabel": "Ակտիվ",
        "pinHint": "Պետք է եզակի լինի ընկերության ներսում։",
        "pinTaken": "Այս PIN-ն արդեն զբաղված է այս ընկերությունում։",
        "pushNotice": "Թարմացված տվյալներն ավտոմատ կուղարկվեն տերմինալներին։",
        "save": "Պահպանել",
        "saving": "Պահպանվում է…",
        "saved": "Աշխատակիցը թարմացվեց, փոփոխություններն ուղարկվեցին տերմինալներին։",
        "saveFailed": "Չհաջողվեց թարմացնել աշխատակցին։ Խնդրում ենք կրկին փորձել։"
      }
    },
    "createCompanyDialog": {
      "title": "Նոր ընկերություն",
      "companyNameLabel": "Ընկերության անուն *",
      "slugLabel": "Նույնարկիչ * (ավտոմատ առաջարկվում է անունից)",
      "adminSectionTitle": "Առաջին ադմինի հաշիվ",
      "adminEmailLabel": "Ադմինի էլ. հասցե *",
      "adminNameLabel": "Ադմինի անուն *",
      "adminPasswordLabel": "Ադմինի գաղտնաբառ (դատարկ թողեք ավտոմատ գեներացման համար)",
      "monthlyRateLabel": "Ամսական տարիֆ (AMD)",
      "monthlyRateHelp": "Թողեք դատարկ կամ 0, եթե հաշվարկը կիրառելի չէ:",
      "submitting": "Ստեղծվում է…",
      "submit": "Ստեղծել ընկերությունը",
      "saveFailed": "Չհաջողվեց ստեղծել ընկերությունը: Խնդրում ենք կրկին փորձել:",
      "successTitle": "Ընկերությունը ստեղծված է",
      "successHint": "Կիսեք ստորև բերված տվյալները նոր ադմինի հետ: Գաղտնաբառն այլևս չի ցուցադրվի:",
      "credentials": {
        "company": "Ընկերություն",
        "slug": "Նույնարկիչ",
        "adminPassword": "Ադմինի գաղտնաբառ"
      },
      "copyPassword": "Պատճենել գաղտնաբառը",
      "toasts": {
        "copied": "Գաղտնաբառը պատճենված է:",
        "copyFailed": "Չհաջողվեց պատճենել:"
      },
      "slugError": "Նույնարկիչը կարող է պարունակել միայն փոքրատառ տառեր, թվեր և գծիկներ:",
      "namePlaceholder": "օր. Acme Corp",
      "slugPlaceholder": "acme-corp"
    },
    "editCompanyDialog": {
      "titleEdit": "Խմբագրել ընկերությունը — {{name}}",
      "companyNameLabel": "Ընկերության անուն",
      "slugLabel": "Նույնարկիչ (միայն կարդալու)",
      "statusHint": "Կարգավիճակ (օգտագործեք Կասեցնել / Վերականգնել ցուցակում)",
      "monthlyRateLabel": "Ամսական տարիֆ (AMD)",
      "monthlyRateHelp": "Թողեք դատարկ կամ 0, եթե հաշվարկը կիրառելի չէ:",
      "saveFailed": "Չհաջողվեց պահպանել: Խնդրում ենք կրկին փորձել:",
      "telegramLabel": "Telegram խումբ",
      "telegramNone": "Միացված չէ",
      "telegramInactiveSuffix": "(բոտը հեռացված է)",
      "telegramHelp": "Ավելացրեք @SensefaceBot-ը հաճախորդի Telegram խմբում — մեկ րոպեի ընթացքում այն կհայտնվի այս ցանկում։",
      "telegramLocaleLabel": "Ծանուցումների լեզուն",
      "telegramTest": "Ուղարկել փորձնական հաղորդագրություն",
      "telegramTesting": "Ուղարկվում է…",
      "telegramTestHint": "Նախ պահպանեք փոփոխությունները, ապա ուղարկեք փորձնականը։",
      "telegramTestSuccess": "Փորձնական հաղորդագրությունն ուղարկվեց — ստուգեք խումբը։",
      "telegramTestFailed": "Չհաջողվեց ուղարկել փորձնական հաղորդագրությունը։"
    },
    "devices": {
      "title": "Սարքեր",
      "subtitle": "Տերմինալները բոլոր ընկերություններում",
      "addNew": "+ Նոր սարք",
      "searchPlaceholder": "Փնտրել սերիական համար / անուն…",
      "failedToLoad": "Չհաջողվեց բեռնել սարքերը",
      "empty": "Սարքեր դեռ չկան",
      "emptyHint": "Սեղմեք + Նոր սարք՝ առաջինը գրանցելու համար:",
      "filters": {
        "allCompanies": "Բոլոր ընկերությունները",
        "allStatuses": "Բոլոր կարգավիճակները",
        "active": "Ակտիվ",
        "inactive": "Ոչ ակտիվ"
      },
      "columns": {
        "serial": "Սերիական համար",
        "name": "Անուն",
        "company": "Ընկերություն",
        "status": "Կարգավիճակ",
        "created": "Ստեղծված",
        "actions": "Գործողություններ"
      },
      "badges": {
        "active": "Ակտիվ",
        "inactive": "Ոչ ակտիվ"
      },
      "actions": {
        "edit": "Խմբագրել",
        "deactivate": "Ապաակտիվացնել",
        "deactivating": "Ապաակտիվացվում է…",
        "activate": "Ակտիվացնել",
        "activating": "Ակտիվացվում է…",
        "delete": "Ջնջել"
      },
      "toasts": {
        "created": "Սարքը ստեղծված է:",
        "activated": "Սարքը ակտիվացված է:",
        "deactivated": "Սարքը ապաակտիվացված է:",
        "toggleFailed": "Չհաջողվեց թարմացնել սարքի կարգավիճակը: Խնդրում ենք կրկին փորձել:",
        "deleted": "Սարքը ջնջված է:",
        "deleteFailed": "Չհաջողվեց ջնջել սարքը: Խնդրում ենք կրկին փորձել:",
        "assignCompanyFirst": "Նախ նշանակեք սարքին ընկերություն («Խմբագրել»), ապա ակտիվացրեք։"
      },
      "confirm": {
        "deactivate": "Ապաակտիվացնե՞լ {{name}} սարքը:",
        "delete": "Ջնջե՞լ {{name}} սարքը:"
      },
      "noCompany": "Առանց ընկերության — նշանակեք «Խմբագրել»-ում"
    },
    "createDeviceDialog": {
      "title": "Նոր սարք",
      "companyLabel": "Ընկերություն *",
      "companyPlaceholder": "Ընտրել ընկերություն",
      "serialLabel": "Սերիական համար *",
      "serialPlaceholder": "օր. ABC123456",
      "nameLabel": "Սարքի անուն *",
      "namePlaceholder": "օր. Մուտք Ա",
      "descriptionLabel": "Նկարագրություն (կամընտիր)",
      "descriptionPlaceholder": "Կարճ նկարագրություն սարքի մասին…",
      "submit": "Ստեղծել սարքը",
      "submitting": "Ստեղծվում է…",
      "saveFailed": "Չհաջողվեց ստեղծել սարքը: Խնդրում ենք կրկին փորձել:"
    },
    "editDeviceDialog": {
      "title": "Խմբագրել սարքը",
      "subtitle": "Վերանվանեք տերմինալը, ուղղեք սերիական համարը կամ փոխանցեք այն այլ ընկերության։",
      "companyLabel": "Ընկերություն *",
      "companyWarning": "Այլ ընկերության փոխանցելիս տերմինալի պատասխանատուն զրոյացվում է, հերթում սպասող հրամանները ջնջվում են, իսկ նախորդ ընկերության աշխատակիցներն անջատվում են։ Ներկայության պատմությունը մնում է նախորդ ընկերությանը։",
      "serialLabel": "Սերիական համար *",
      "serialHint": "Պետք է համընկնի տերմինալի հաղորդած SN-ի հետ, հակառակ դեպքում սարքը կրկին կգրանցվի որպես սպասող։",
      "nameLabel": "Սարքի անուն",
      "descriptionLabel": "Նկարագրություն",
      "save": "Պահպանել",
      "saving": "Պահպանվում է…",
      "saved": "Սարքը թարմացված է:",
      "saveFailed": "Չհաջողվեց թարմացնել սարքը: Խնդրում ենք կրկին փորձել:",
      "moved": "Սարքը փոխանցվեց «{{company}}» ընկերությանը։"
    },
    "users": {
      "title": "Օգտատերեր",
      "subtitle": "Վեբ օգտատերերը բոլոր ընկերություններում",
      "addNew": "+ Նոր օգտատեր",
      "searchPlaceholder": "Փնտրել անուն / էլ. հասցե…",
      "failedToLoad": "Չհաջողվեց բեռնել օգտատերերը",
      "empty": "Օգտատերեր դեռ չկան",
      "emptyHint": "Սեղմեք + Նոր օգտատեր՝ առաջին հաշիվը ստեղծելու համար:",
      "filters": {
        "allCompanies": "Բոլոր ընկերությունները",
        "allRoles": "Բոլոր դերերը",
        "allStatuses": "Բոլոր կարգավիճակները",
        "active": "Ակտիվ",
        "inactive": "Ոչ ակտիվ"
      },
      "columns": {
        "name": "Անուն",
        "email": "Էլ. հասցե",
        "role": "Դեր",
        "company": "Ընկերություն",
        "status": "Կարգավիճակ",
        "created": "Ստեղծված",
        "actions": "Գործողություններ"
      },
      "badges": {
        "active": "Ակտիվ",
        "inactive": "Ոչ ակտիվ",
        "user": "Օգտատեր",
        "admin": "Ադմինիստրատոր",
        "super_admin": "Գերադմինիստրատոր",
        "platform_admin": "Հարթակի ադմինիստրատոր"
      },
      "actions": {
        "deactivate": "Ապաակտիվացնել",
        "deactivating": "Ապաակտիվացվում է…",
        "activate": "Ակտիվացնել",
        "activating": "Ակտիվացվում է…",
        "delete": "Ջնջել",
        "edit": "Խմբագրել"
      },
      "toasts": {
        "created": "Օգտատերը ստեղծված է:",
        "activated": "Օգտատերը ակտիվացված է:",
        "deactivated": "Օգտատերը ապաակտիվացված է:",
        "toggleFailed": "Չհաջողվեց թարմացնել օգտատիրոջ կարգավիճակը: Խնդրում ենք կրկին փորձել:",
        "deleted": "Օգտատերը ջնջված է:",
        "deleteFailed": "Չհաջողվեց ջնջել օգտատիրոջը: Խնդրում ենք կրկին փորձել:"
      },
      "confirm": {
        "deactivate": "Ապաակտիվացնե՞լ {{name}} օգտատիրոջը:",
        "delete": "Ջնջե՞լ {{name}} օգտատիրոջը: Սա հնարավոր չի լինի հետարկել:"
      },
      "errors": {
        "cannotTogglePlatformAdmin": "Հարթակի ադմինիստրատորի հաշիվները հնարավոր չէ ապաակտիվացնել:",
        "cannotToggleSelf": "Հնարավոր չէ ապաակտիվացնել սեփական հաշիվը:"
      }
    },
    "editUserDialog": {
      "title": "Խմբագրել օգտատիրոջը",
      "nameLabel": "Անուն",
      "roleLabel": "Դեր",
      "companyLabel": "Ընկերություն",
      "passwordLabel": "Նոր գաղտնաբառ",
      "passwordPlaceholder": "Թողեք դատարկ՝ չփոխելու համար",
      "passwordHint": "Առնվազն 8 նիշ։ Լրացրեք միայն փոխելու դեպքում։",
      "save": "Պահպանել",
      "saving": "Պահպանվում է…",
      "saved": "Օգտատերը թարմացվեց։",
      "saveFailed": "Չհաջողվեց թարմացնել օգտատիրոջը։ Խնդրում ենք կրկին փորձել։"
    },
    "createUserDialog": {
      "title": "Նոր օգտատեր",
      "companyLabel": "Ընկերություն *",
      "companyPlaceholder": "Ընտրել ընկերություն",
      "nameLabel": "Անուն *",
      "namePlaceholder": "Լրիվ անուն",
      "emailLabel": "Էլ. հասցե *",
      "emailPlaceholder": "user@example.com",
      "passwordLabel": "Գաղտնաբառ",
      "passwordPlaceholder": "Նվազ. 8 նիշ",
      "autoGenerateLabel": "Ավտոմատ գեներացնել գաղտնաբառ",
      "roleLabel": "Դեր *",
      "submit": "Ստեղծել օգտատիրոջը",
      "submitting": "Ստեղծվում է…",
      "saveFailed": "Չհաջողվեց ստեղծել օգտատիրոջը: Խնդրում ենք կրկին փորձել:",
      "successTitle": "Օգտատերը ստեղծված է",
      "successHint": "Կիսեք գեներացված գաղտնաբառը նոր օգտատիրոջ հետ: Այն այլևս չի ցուցադրվի:",
      "credentials": {
        "name": "Անուն",
        "email": "Էլ. հասցե",
        "password": "Գեներացված գաղտնաբառ"
      },
      "copyPassword": "Պատճենել գաղտնաբառը",
      "toasts": {
        "copied": "Գաղտնաբառը պատճենված է:",
        "copyFailed": "Չհաջողվեց պատճենել:"
      },
      "suspendedSuffix": " (կասեցված)"
    },
    "billing": {
      "title": "Բիլլինգ",
      "subtitle": "Հաշվեգրումներ, վճարումներ և պարտք ըստ ընկերությունների",
      "searchPlaceholder": "Փնտրել ընկերություններ…",
      "failedToLoad": "Չհաջողվեց բեռնել բիլլինգի տվյալները",
      "empty": "Ընկերություններ չեն գտնվել",
      "emptySearch": "Որոնման արդյունքներ չկան:",
      "columns": {
        "company": "Ընկերություն",
        "rate": "Տարիֆ/ամս",
        "devices": "Սարքեր",
        "accrued": "Կուտակված",
        "paid": "Վճարված",
        "outstanding": "Մնացորդ",
        "lastPayment": "Վերջին վճարում",
        "actions": "Գործողություններ"
      },
      "status": {
        "credit": "կրեդիտ",
        "paidInFull": "լրիվ վճարված",
        "owes": "պարտք"
      },
      "actions": {
        "recordPayment": "Գրանցել վճարումը",
        "viewDetail": "Դիտել"
      },
      "recordPaymentDialog": {
        "title": "Գրանցել վճարումը",
        "companyLabel": "Ընկերություն *",
        "companyPlaceholder": "Ընտրել ընկերություն",
        "amountLabel": "Գումար (AMD) *",
        "amountPlaceholder": "օր. 12500",
        "paidAtLabel": "Վճարման ամսաթիվ *",
        "noteLabel": "Նշում (կամընտիր)",
        "notePlaceholder": "Բանկային փոխանցման հղման համար…",
        "submit": "Գրանցել վճարումը",
        "submitting": "Գրանցվում է…",
        "saveFailed": "Չհաջողվեց գրանցել վճարումը: Խնդրում ենք կրկին փորձել:",
        "toasts": {
          "recorded": "Վճարումը գրանցված է:",
          "recordFailed": "Չհաջողվեց գրանցել վճարումը:"
        },
        "errors": {
          "amountTooLow": "Գումարը պետք է լինի առնվազն 1 AMD:",
          "dateInFuture": "Ամսաթիվը չի կարող լինել ապագայում:",
          "idempotencyCollision": "Այս վճարումն արդեն գրանցված է:"
        }
      },
      "voidPaymentDialog": {
        "title": "Անվավերացնել վճարումը",
        "message": "Անվավերացնե՞լ {{amount}} վճարումը {{date}}-ից: Գրառումը կպահվի, բայց ընդհանուր գումարներում չի հաշվի:",
        "reasonLabel": "Պատճառ (կամընտիր)",
        "reasonPlaceholder": "օր. Մուտքագրվել է սխալմամբ",
        "submit": "Անվավերացնել",
        "submitting": "Անվավերացվում է…",
        "toasts": {
          "voided": "Վճարումը անվավերացված է:",
          "voidFailed": "Չհաջողվեց անվավերացնել վճարումը:"
        }
      },
      "invoice": {
        "number": "Հաշիվ-ապրանքագիր №",
        "downloadPdf": "Ներբեռնել PDF",
        "emailSent": "Ուղարկվել է {{date}}",
        "emailPending": "Սպասում է",
        "emailNoRecipients": "Ստացողներ չկան",
        "resend": "Կրկին ուղարկել",
        "resendConfirmTitle": "Կրկին ուղարկե՞լ հաշիվ-ապրանքագիրը:",
        "resendConfirmBody": "{{company}} ընկերության բոլոր ադմիններն կստանան նոր նամակ հաշիվ-ապրանքագրի PDF-ով:",
        "resendSuccess": "Նամակը հերթի դրվել է ուղարկման համար",
        "resendError": "Չհաջողվեց հերթի դնել: Փորձեք կրկին:",
        "downloadError": "Չհաջողվեց ներբեռնել PDF-ը: Փորձեք կրկին:"
      },
      "detail": {
        "backLink": "Վերադառնալ բիլլինգ",
        "monthlyRate": "Ամսական տարիֆ",
        "billingStarted": "Բիլլինգի սկիզբ",
        "noBillingStart": "Նշված չէ",
        "totalsSection": "Ընդամենը",
        "totalAccrued": "Ընդհանուր կուտակված",
        "totalPaid": "Ընդհանուր վճարված",
        "outstanding": "Մնացորդ",
        "invoicesSection": "Հաշիվ-ապրանքագրեր",
        "paymentsSection": "Վճարումներ",
        "noInvoices": "Հաշիվ-ապրանքագրեր դեռ չկան:",
        "noPayments": "Վճարումներ դեռ չկան:",
        "invoiceColumns": {
          "period": "Ժամանակաշրջան",
          "devices": "Սարքեր",
          "rate": "Տարիֆ",
          "amount": "Գումար",
          "created": "Ստեղծված"
        },
        "paymentColumns": {
          "datePaid": "Վճարման ամսաթիվ",
          "amount": "Գումար",
          "note": "Նշում",
          "recordedBy": "Գրանցողը",
          "status": "Կարգավիճակ",
          "actions": "Գործողություններ"
        },
        "paymentStatus": {
          "active": "Ակտիվ",
          "voided": "Անվավեր"
        },
        "voidedReason": "Անվավերացման պատճառ",
        "actions": {
          "void": "Անվավերացնել",
          "voided": "Անվավեր"
        },
        "failedToLoad": "Չհաջողվեց բեռնել բիլլինգի տվյալները:"
      },
      "companyFields": {
        "monthlyRateLabel": "Ամսական տարիֆ (AMD)",
        "monthlyRateHelp": "Թողեք դատարկ կամ 0, եթե հաշվարկը կիրառելի չէ:"
      }
    },
    "invoices": {
      "title": "Հաշիվ-ապրանքագրեր",
      "subtitle": "Բոլոր դուրս գրված հաշիվները",
      "failedToLoad": "Չհաջողվեց բեռնել հաշիվ-ապրանքագրերը",
      "empty": "Հաշիվ-ապրանքագրեր դեռ չկան",
      "emptyHint": "Հաշիվ-ապրանքագրերն ավտոմատ ստեղծվում են ամեն ամսի 1-ին",
      "emptyFiltered": "Ոչ մի հաշիվ-ապրանքագիր չի համապատասխանում ֆիլտրերին",
      "filters": {
        "allCompanies": "Բոլոր ընկերությունները",
        "allStatuses": "Բոլոր կարգավիճակները",
        "monthLabel": "Ամիս",
        "statusLabel": "Էլ. նամակի կարգավիճակ",
        "companyLabel": "Ընկերություն",
        "clear": "Մաքրել"
      },
      "columns": {
        "number": "Հաշիվ-ապրանքագիր №",
        "company": "Ընկերություն",
        "period": "Ժամանակաշրջան",
        "devices": "Սարքեր",
        "rate": "Տարիֆ",
        "amount": "Գումար",
        "status": "Կարգավիճակ",
        "actions": "Գործողություններ"
      },
      "status": {
        "sent": "Ուղարկված",
        "pending": "Սպասում է",
        "noRecipients": "Ստացողներ չկան"
      }
    },
    "telegramChats": {
      "title": "Telegram չաթեր",
      "subtitle": "Խմբերը, որտեղ ավելացվել է բոտը — ցանկը թարմացվում է ավտոմատ՝ մեկ րոպեի ընթացքում",
      "empty": "Չաթեր դեռ չկան",
      "emptyHint": "Ավելացրեք @SensefaceBot-ը հաճախորդի Telegram խմբում — այն կհայտնվի այստեղ մեկ րոպեի ընթացքում։",
      "failedToLoad": "Չհաջողվեց բեռնել չաթերը",
      "columns": {
        "title": "Խումբ",
        "chatId": "Chat ID",
        "status": "Կարգավիճակ",
        "company": "Ընկերություն",
        "updated": "Թարմացվել է"
      },
      "statusActive": "Բոտը չաթում է",
      "statusRemoved": "Բոտը հեռացված է",
      "notAttached": "Կցված չէ",
      "attachHint": "Չաթը ընկերությանը կցելով այստեղ՝ միանում են նրա ծանուցումները․ լեզուն սահմանվում է Ընկերություններ → Փոփոխել → Telegram բաժնում։",
      "attachSuccess": "Կապը թարմացվեց։",
      "attachFailed": "Չհաջողվեց թարմացնել կապը։",
      "confirmReplace": "«{{company}}»-ն արդեն կցված է «{{chat}}» խմբին։ Փոխարինե՞լ այս խմբով։",
      "live": "թարմացվում է ինքնաբերաբար",
      "deleteAria": "Հեռացնել չաթը",
      "confirmDelete": "Հեռացնե՞լ «{{chat}}» խումբը ցանկից։ Եթե այն կցված է ընկերության, այդ ընկերության ծանուցումները կանջատվեն։",
      "deleteSuccess": "Չաթը հեռացվեց։",
      "deleteFailed": "Չհաջողվեց հեռացնել չաթը։"
    },
    "nav": {
      "clients": "Հաճախորդներ",
      "finance": "Ֆինանսներ",
      "communication": "Կապ"
    },
    "overview": {
      "title": "Ընդհանուր",
      "subtitle": "Ամբողջ հարթակի հիմնական ցուցանիշները",
      "tiles": {
        "companies": "Ընկերություններ",
        "companiesHint": "ակտիվ՝ {{active}}",
        "devices": "Տերմինալներ",
        "devicesHint": "միացված բոլոր ընկերություններում",
        "outstanding": "Պարտք",
        "outstandingHint": "ամսական սակագինը ընդամենը՝ {{rate}}",
        "newRequests": "Նոր հայտեր",
        "newRequestsHint": "լենդինգի ձևից"
      },
      "debtors": {
        "title": "Պարտապաններ",
        "empty": "Ամեն ինչ վճարված է",
        "lastPayment": "վերջին վճարումը՝",
        "viewAll": "Բացել բիլինգը"
      },
      "requests": {
        "title": "Վերջին հայտերը",
        "empty": "Նոր հայտեր չկան",
        "viewAll": "Բոլոր հայտերը"
      }
    }
  }
}
